// extracted by mini-css-extract-plugin
module.exports = {"main":"revent_main__2OZYw","head":"revent_head__37yrC","reventReport":"revent_reventReport__2rRRT","reventReports":"revent_reventReports__1yGAe"};